export const encodeNativeSelectKey = <T>(key: T): string => {
	return JSON.stringify({ key: key });
};

export const decodeNativeSelectKey = (value: string): any => {
	const key = JSON.parse(value).key;
	if (key === "") return null;
	return key;
};
